import {useState, useEffect} from "react";
import axios from "axios";

export const baseUrl = `https://backend.alphacapitalgroup.uk/`;

const useFetch = (url) => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState(null);
  const [serverError, setServerError] = useState(null);
  const [isFetched, setIsFetched] = useState(false);

  const fetchData = async () => {
    try {
      const resp = await axios.get(url);
      const data = resp?.data;
      setApiData(data);
    } catch (error) {
      setServerError(error);
    } finally {
      setIsLoading(false);
      setIsFetched(true);
    }
  };

  useEffect(() => {
    if (!isFetched) {
      fetchData();
    }
  }, [url, isFetched]);

  return {isLoading, apiData, serverError};
};

export default useFetch;
